import React from 'react';
import PropTypes from 'prop-types';
import YourDataWho from './YourDataWho';
import YourDataProduct from './YourDataProduct';
import YourDataInfo3 from './YourDataInfo3';
import YourDataDeliveryDate from './YourDataDeliveryDate';
import YourDataDeliveryAddress from './YourDataDeliveryAddress';
import YourDataNotes from './YourDataNotes';
import s from './YourData.module.scss';

function YourData(props) {
  const { values } = props;
  const { product, category, information, windFacilityFile } = values;
  const { end, start, notes, file } = information;

  let filenames = null;
  if (file || windFacilityFile) {
    filenames = [];
    if (windFacilityFile) {
      filenames.push(windFacilityFile.name);
    }
    if (file) {
      filenames.push(file.name);
    }
  }

  const data = [
    { key: 'who', element: <YourDataWho category={category} /> },
    { key: 'product', element: <YourDataProduct product={product} /> },
    { key: 'infoStep3', element: <YourDataInfo3 values={values} /> },
  ];

  if (product !== 'pvGrossanlage' && (start || end)) {
    data.push({
      key: 'dates',
      element: (
        <YourDataDeliveryDate start={start} end={end} product={product} />
      ),
    });
  }

  data.push({
    key: 'address',
    element: <YourDataDeliveryAddress information={information} />,
  });
  data.push({
    key: 'notes',
    element: <YourDataNotes notes={notes} filenames={filenames} />,
  });

  return (
    <ol className={s.summaryGrid}>
      {data.map(({ key, element }) => (
        <li key={key} className={s.summaryElement}>
          {element}
        </li>
      ))}
    </ol>
  );
}

YourData.propTypes = {
  values: PropTypes.shape({
    category: PropTypes.string.isRequired,
    product: PropTypes.string.isRequired,
    information: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
      notes: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      file: PropTypes.object,
    }),
    // eslint-disable-next-line react/forbid-prop-types
    windFacilityFile: PropTypes.object,
  }).isRequired,
};

export default YourData;
